import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import MediaKitsSection from "../../components/MediaKitsSection/mediaKitsSection";
import EventsSection from "../../components/EventsSection/eventsSection";
import BlogsSection from "../../components/BlogsSection/blogsSection";
import PressReleaseSection from "../../components/PressReleaseSection/pressReleaseSection";
import ThoughtLeadershipSection from "../../components/ThoughtLeadership/thoughtLeadership";

export default function WDBanner() {
  const { t } = useTranslation();

  const i18nSections = t("newsroom_sections", { returnObjects: true });
  const sections = Array.isArray(i18nSections) && i18nSections.length
    ? i18nSections
    : [
        { id: "overview", label: "Overview", href: "/company/newsroom" },
        { id: "press", label: "Press Releases", href: "/company/newsroom/press-releases" },
        { id: "media", label: "Media Kits", href: "/company/newsroom/media-kits" },
        { id: "events", label: "Events", href: "/company/newsroom/events" },
        { id: "blogs", label: "Blogs", href: "/company/newsroom/blogs" }
      ];

  function getLocalePrefix() {
    if (typeof window === "undefined") return "";
    const m = window.location.pathname.match(/^\/([a-z]{2}-[a-z]{2})(?=\/|$)/i);
    return m ? `/${m[1]}` : "";
  }

  function stripLocale(pathname) {
    return pathname.replace(/^\/[a-z]{2}-[a-z]{2}(?=\/|$)/i, "") || "/";
  }

  function handleNav(id, href) {
    const prefix = getLocalePrefix();
    const dest = `${prefix}${href}`;
    if (id === "overview") {
      window.location.href = dest;
    } else {
      const url = new URL(dest, window.location.origin);
      url.searchParams.delete("page");
      window.history.pushState({}, "", url);
      window.dispatchEvent(new PopStateEvent("popstate"));
    }
  }

  function getActiveId(list) {
    const raw = typeof window !== "undefined" ? window.location.pathname : "";
    const path = stripLocale(raw);
    const exact = list.find(s => path === s.href || path === `${s.href}/`);
    if (exact) return exact.id;
    const match = list.find(s => s.href !== "/company/newsroom" && path.startsWith(s.href));
    return match ? match.id : "overview";
  }

  const activeId = getActiveId(sections);
  const currentCrumb = activeId !== "overview" ? (sections.find(s => s.id === activeId)?.label || null) : null;

  const titleKey = `newsroom_title_${activeId}`;
  const descKey = `newsroom_desc_${activeId}`;
  const h1Title = t(titleKey, t("newsroom_title_overview"));
  const subText = t(descKey, t("newsroom_desc_overview"));

  const ROWS = 12;
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const read = () => {
      const p = parseInt(new URL(window.location.href).searchParams.get("page") || "1", 10);
      return Number.isFinite(p) && p > 0 ? p : 1;
    };
    setPage(read());
    const onPop = () => setPage(read());
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, [activeId]);

  function onTotal(totalItems) {
    const total = Number(totalItems) || 0;
    const pc = Math.max(1, Math.ceil(total / ROWS));
    setPageCount(pc);
    if (page > pc) goToPage(pc, { scroll: false });
  }

  function goToPage(next, opts = { scroll: true }) {
    if (typeof window === "undefined") return;
    const n = Math.max(1, Math.min(next, pageCount));
    setPage(n);
    const url = new URL(window.location.href);
    if (n === 1) url.searchParams.delete("page"); else url.searchParams.set("page", String(n));
    window.history.pushState({}, "", url);
    window.dispatchEvent(new PopStateEvent("popstate"));
    if (opts.scroll) {
      const a = document.getElementById("newsroom-top");
      if (a) a.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  function makeRange(count, current, siblingCount = 1) {
    const totalNumbers = siblingCount * 2 + 5;
    if (count <= totalNumbers) return Array.from({ length: count }, (_, i) => i + 1);
    const left = Math.max(2, current - siblingCount);
    const right = Math.min(count - 1, current + siblingCount);
    const showLeftDots = left > 2;
    const showRightDots = right < count - 1;
    const arr = [1];
    if (showLeftDots) arr.push("…");
    for (let p = left; p <= right; p++) arr.push(p);
    if (showRightDots) arr.push("…");
    arr.push(count);
    return arr;
  }

  const bcHome = t("breadcrumbs.home", "Home");
  const bcCompany = t("breadcrumbs.company", "Company");
  const bcNewsroom = t("breadcrumbs.newsroom", "Newsroom");

  return (
    <div className="w-full relative container contain mx-auto">
      <style>
        {`
            .section-119513841787 {
              background-size: cover;
              background-position: center;
              background-repeat: no-repeat;
            }
            .webp .section-119513841787 {
              background-image: url(https://www.westerndigital.com/content/dam/store/en-us/assets/company/hero_subpages.jpg.wdthumb.3000.3000.webp.wdthumb.840.840.webp)!important;
            }
            .no-webp .section-119513841787 {
              background-image: url(https://www.westerndigital.com/content/dam/store/en-us/assets/company/hero_subpages.jpg.wdthumb.3000.3000.webp.thumb.840.840.png)!important;
            }
            @media (min-width: 768px) {
              .webp .section-119513841787 {
                background-image: url(https://www.westerndigital.com/content/dam/store/en-us/assets/company/hero_subpages.jpg.wdthumb.3000.3000.webp.wdthumb.1280.1280.webp)!important;
              }
              .no-webp .section-119513841787 {
                background-image: url(https://www.westerndigital.com/content/dam/store/en-us/assets/company/hero_subpages.jpg.wdthumb.3000.3000.webp.thumb.1280.1280.png)!important;
              }
            }
            @media (min-width: 992px) {
              .webp .section-119513841787 {
                background-image: url(https://www.westerndigital.com/content/dam/store/en-us/assets/company/hero_subpages.jpg.wdthumb.3000.3000.webp.wdthumb.3000.3000.webp)!important;
              }
              .no-webp .section-119513841787 {
                background-image: url(https://www.westerndigital.com/content/dam/store/en-us/assets/company/hero_subpages.jpg.wdthumb.3000.3000.webp.thumb.3000.3000.png)!important;
              }
            }
          `}
      </style>

      <section>
        <div className="flex flex-wrap lg:flex-row grid-12 md:grid-12 border-b border-grey-light">
          <div className="cols-12 md:cols-12">
            <div className="flex-wrap md:flex grid-12 xs:grid-12 sm:grid-12 md:grid-12 lg:grid-12 xl:grid-12">
              <div className="cols-12 md:cols-9">
                <div className="-mx-4 xs:mx-0 flex xs:justify-between whitespace-no-wrap overflow-x-auto md:overflow-hidden md:relative md:z-1 pin-t-px">
                  {sections.map((n) => (
                    <button
                      key={n.id}
                      className={`py-3 mt-2 mb-0 text-sm md:text-base mx-8 block mx-1 ${activeId === n.id ? "border-b-2 border-blue text-blue" : ""}`}
                      style={{ outline: "none" }}
                      onClick={() => handleNav(n.id, n.href)}
                    >
                      {n.label}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="section">
        <section data-rellax-percentage="0.35" className=" bg-color relative section text-white py-0" style={{ backgroundColor: "rgb(0, 0, 0)" }}>
          <div className="relative ">
            <div className="responsive-columns-flexbox">
              <div className=" row grid-12 xs:grid-12 sm:grid-12 md:grid-12 lg:grid-12 xl:grid-12 flex-wrap md:flex flex ">
                <div className="cols-12 md:cols-6 lg:cols-4 order-2 md:order-1">
                  <div className="section">
                    <section data-rellax-percentage="0.35" className=" bg-color relative section py-6 md:py-12 px-6 md:px-12 min-h-225px py-0 flex items-center py-0" style={{backgroundColor: "rgba(255, 255, 255, 0)"}}>
                      <div className="relative ">
                        <div className="bread-crumbs">
                          <div style={{clear: "both"}}></div>
                        </div>
                        <div className="title">
                          <div>
                            <h1 className="heading1" style={{ color: "rgb(255, 255, 255)" }}>{h1Title}</h1>
                          </div>
                          <div style={{clear: "both"}}></div>
                        </div>
                        <div className="text">
                          <div className="  textcolumn">
                            <p className="text-base">{subText}<br/></p>
                            {activeId === "blogs" && (
                              <div className="mt-3">
                                <a
                                  className="underline"
                                  href="https://blog.westerndigital.com/"
                                  target="_self"
                                  rel="noreferrer"
                                >
                                  {t("newsroom_cta_blogs")}
                                </a>
                              </div>
                            )}
                          </div>
                          <div style={{clear: "both"}}></div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
                <div className="cols-12 md:cols-6 lg:cols-8 order-1 md:order-2 expand-h-full">
                  <div className="section">
                    <section className=" bg-color relative section min-h-225px h-full py-0">
                      <div className="aem-section-bgimage section-119513841787 section-bg absolute pin-t pin-b pin-l pin-r lazyloading" data-bgimage="/content/dam/store/en-us/assets/company/hero_subpages.jpg" ></div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div className="bread-crumbs">
        <div className="defaultBreadcrumbView abc">
          <div
            className="my-6 flex flex-wrap items-center"
            itemScope
            itemType="https://schema.org/BreadcrumbList"
          >
            <div
              itemProp="itemListElement"
              itemScope
              itemType="https://schema.org/ListItem"
              className="flex flex-wrap items-center"
            >
              <a
                className="text-sm hover:text-bold text-grey-3 hover:text-black hover:underline inline-block testClass111"
                itemProp="item"
                href={`${(typeof window!=="undefined"?window.location.origin:"")}/${(((typeof window!=="undefined"&&(window.location.pathname.match(/^\/([a-z]{2}-[a-z]{2})(?=\/|$)/i)||[])[1])||"en-us")).toLowerCase()}/`}
                data-track-type="breadcrumb"
              >
                <span itemProp="name">{bcHome}</span>
              </a>
              <meta itemProp="position" content="1" />
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
                <path d="M0,0H21V21H0Z" fill="none"></path>
                <path d="M11.572,9.943l-3.35-3.35.957-.957,4.307,4.307L9.179,14.251l-.957-.957Z" transform="translate(-0.028 0.818)" fill="#6a6a6a"></path>
              </svg>
            </div>

            <div
              itemProp="itemListElement"
              itemScope
              itemType="https://schema.org/ListItem"
              className="flex flex-wrap items-center"
            >
              <a
                className="text-sm hover:text-bold text-grey-3 hover:text-black hover:underline inline-block"
                itemProp="item"
                href={`${(typeof window!=="undefined"?window.location.origin:"")}/${(((typeof window!=="undefined"&&(window.location.pathname.match(/^\/([a-z]{2}-[a-z]{2})(?=\/|$)/i)||[])[1])||"en-us")).toLowerCase()}/company`}
                data-track-type="breadcrumb"
              >
                <span itemProp="name">{bcCompany}</span>
              </a>
              <meta itemProp="position" content="2" />
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
                <path d="M0,0H21V21H0Z" fill="none"></path>
                <path d="M11.572,9.943l-3.35-3.35.957-.957,4.307,4.307L9.179,14.251l-.957-.957Z" transform="translate(-0.028 0.818)" fill="#6a6a6a"></path>
              </svg>
            </div>

            <div
              itemProp="itemListElement"
              itemScope
              itemType="https://schema.org/ListItem"
              className="flex flex-wrap items-center"
            >
              {currentCrumb ? (
                <>
                  <a
                    className="text-sm hover:text-bold text-grey-3 hover:text-black hover:underline inline-block"
                    itemProp="item"                    
                    href={`${(typeof window!=="undefined"?window.location.origin:"")}/${(((typeof window!=="undefined"&&(window.location.pathname.match(/^\/([a-z]{2}-[a-z]{2})(?=\/|$)/i)||[])[1])||"en-us")).toLowerCase()}/company/newsroom`}
                    data-track-type="breadcrumb"
                  >
                    <span itemProp="name">{bcNewsroom}</span>
                  </a>
                  <meta itemProp="position" content="3" />
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
                    <path d="M0,0H21V21H0Z" fill="none"></path>
                    <path d="M11.572,9.943l-3.35-3.35.957-.957,4.307,4.307L9.179,14.251l-.957-.957Z" transform="translate(-0.028 0.818)" fill="#6a6a6a"></path>
                  </svg>
                </>
              ) : (
                <>
                  <span className="text-sm text-black font-bold" itemProp="name">{bcNewsroom}</span>
                  <meta itemProp="position" content="3" />
                </>
              )}
            </div>

            {currentCrumb && (
              <div
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
                className="flex flex-wrap items-center"
              >
                <span className="text-sm text-black font-bold" itemProp="name">
                  {currentCrumb}
                </span>
                <meta itemProp="position" content="4" />
              </div>
            )}
          </div>
        </div>
      </div>

      <div id="newsroom-top" className="scroll-mt-24"></div>
      {typeof window !== "undefined" && (
        <>
          {activeId === "press" && (
            <PressReleaseSection page={page} rows={ROWS} onTotal={onTotal} />
          )}
          {activeId === "blogs" && (
            <BlogsSection page={page} rows={ROWS} onTotal={onTotal} />
          )}
          {activeId === "events" && (
            <EventsSection page={page} rows={ROWS} onTotal={onTotal} />
          )}
          {activeId === "media" && (
            <MediaKitsSection page={page} rows={ROWS} onTotal={onTotal} />
          )}
          {pageCount > 1 && (
            <nav aria-label="Pagination" className="clp-pagination-wrap my-10">
              <div className="mt-8 xs:mt-12 sm:flex justify-center items-center">
                <ul className="list-reset flex items-center justify-center relative sm:w-[500px] md:w-full">
                  <button
                    id="prevbtn"
                    onClick={() => goToPage(page - 1)}
                    disabled={page <= 1}
                    className="btnprev md:pr-12 pr-10 flex items-center absolute lg:relative wd-left-0 -wd-top-[25px] lg:wd-top-0 lg:pr-3
                              disabled:wd-opacity-40 disabled:wd-cursor-not-allowed disabled:wd-pointer-events-none focus:wd-outline focus:wd-outline-2 focus:wd-outline-[#c59d28]"
                  >
                    <svg aria-hidden="true" className="w-6 h-6 rotate-180 mr-1" viewBox="0 0 24 24">
                      <path fill="none" d="M0 0h24v24H0z" />
                      <path d="M17.818 23.015 12.7 17.875l.725-.725 4.393 4.393 4.393-4.393.725.747Z"
                            transform="translate(-7.143 29.7) rotate(-90)" stroke="currentColor" />
                    </svg>
                    <span className="pagination-prev font-medium leading-tight">{t("pagination.prev")}</span>
                  </button>

                  {makeRange(pageCount, page, 1).map((p, i) =>
                    p === "…" ? (
                      <li key={`dots-${i}`} className="dots mt-1 sm:mt-0 md:mx-3 mx-1 cursor-default">
                        <span className="inline h-12 w-12 leading-[3rem] select-none">...</span>
                      </li>
                    ) : (
                      <li key={p} className="mt-1 sm:mt-0 md:mx-3 mx-1">
                        <button
                          aria-current={p === page ? "page" : undefined}
                          onClick={() => goToPage(p)}
                          className={`flex justify-center items-center numbers leading-loose wd-rounded-full cursor-pointer
                                      h-12 w-12 px-5 py-2 hover:wd-bg-[#f2f3f3] focus:wd-outline focus:wd-outline-2 focus:wd-outline-[#c59d28]
                                      ${p === page ? "active wd-rounded-full wd-bg-[#f2f3f3]" : ""}`}
                          title={`Page ${p}`}
                        >
                          {p}
                        </button>
                      </li>
                    )
                  )}
                  <button
                    id="nextbtn"
                    onClick={() => goToPage(page + 1)}
                    disabled={page >= pageCount}
                    className="btnnext md:pl-12 pl-10 flex items-center absolute lg:relative wd-right-0 -wd-top-[25px] lg:wd-top-0 lg:pl-3
                              disabled:wd-opacity-40 disabled:wd-cursor-not-allowed disabled:wd-pointer-events-none focus:wd-outline focus:wd-outline-2 focus:wd-outline-[#c59d28]"
                  >
                    <span className="font-medium leading-tight mr-1">{t("pagination.next")}</span>
                    <svg aria-hidden="true" className="w-6 h-6" viewBox="0 0 24 24">
                      <path fill="none" d="M0 0h24v24H0z" />
                      <path d="M17.818 23.015 12.7 17.875l.725-.725 4.393 4.393 4.393-4.393.725.747Z"
                            transform="translate(-7.143 29.7) rotate(-90)" stroke="currentColor" />
                    </svg>
                  </button>
                </ul>
              </div>
            </nav>
          )}
        </>
      )}
      <ThoughtLeadershipSection />
    </div>
  );
}
